import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://makicheck.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token a las peticiones
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  // Login para trabajadores
  async login(email: string, password: string) {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  // Login para empresas
  async loginCompany(company_id: string, pin: string) {
    const response = await api.post('/auth/login-company', { company_id, pin });
    return response.data;
  },

  // Login para super admin
  async loginSuperAdmin(username: string, password: string) {
    const response = await api.post('/auth/login-super-admin', { username, password });
    return response.data;
  },

  // Verificar token
  async verifyToken() {
    const response = await api.get('/auth/verify');
    return response.data.user;
  },

  // Logout
  async logout() {
    const response = await api.post('/auth/logout');
    return response.data;
  },
};
